import { useContext } from 'react';
import { __RouterContext } from 'react-router';

export default () => useContext(__RouterContext);